<template>
	<div class="newsSecondPage1">
		<div class="rightMore">
			<div class="search-box">
				<!-- <input type="text" v-model="msg"> -->
				<el-input type="text" v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter.native="serchEnterFn" class="input-with-select">
				</el-input>
				<img src='@/assets/imgs/home/searchicon.png' @click.stop="serchEnterFn" />
			</div>
		</div>
		<div v-if="dataList.length!=0">
			<div class="newsbox">
				<div class="aloneInfoItem" v-for="(item,index) in dataList" :key="index" @click="showremarkFn(item.remark)">
					<div class="memberName overflowone">{{item.corpInfoName}}</div>
					<div class="memberGrade">{{item.memberlevel}}</div>
					<div class="memberSite" v-if="item.regionalCode">
						<i class="el-icon-location iconwarp" />{{item.regionalCode}}
					</div>
				</div>
			</div>
			<div class="pagination-box">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				    :page-sizes="[8, 12, 16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="emptyBox" v-else>
			<img src="@/assets/imgs/home/emptyimg.png" />
		</div>
		<!-- 弹框 -->
		<el-dialog title="简介" :visible.sync="remarkVisible" width="1200px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
		    :append-to-body="true">
			<div class="singupdialogcenter">
				{{currentRemark?currentRemark:'暂无简介~'}}
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
	},
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			total: 10,
			pageSize: 8,
			dataList: [],
			currentRemark: null,
			remarkVisible: false,
			searchVal: null,//搜索字段
		}
	},
	created() {
		this.getNews()
	},
	methods: {
		serchEnterFn() {
			this.getNews()
		},
		async getNews() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				findAll: this.searchVal
			};
			let data = await httpService.findMember(params);
			if (data.code == 200) {
				this.dataList = data.result.list
				this.total = data.result.total;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.getNews();
		},
		handleCurrentChange(val) {
			// this.pageSize = 1;
			this.currentPage = val;
			this.getNews();
		},
		showremarkFn(val) {
			this.currentRemark = val;
			this.remarkVisible = true
		}
	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.newsSecondPage1 {
	width: 1200px;
	.rightMore {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 16px;

		.search-box {
			// background: #1088fe;
			width: 266px;
			justify-content: center;
			align-items: center;
			align-content: center;
			text-align: center;
			// padding: 30px 0px;
			height: 40px;
			display: flex;
			flex-direction: row;
			// margin-right: 32px;
			position: relative;
			/deep/.el-input__inner {
				// background-color: #68b4ff;
				border: 1px solid #cacaca;
				color: #000 !important;
				border-radius: 20px;
			}
			/deep/input::placeholder {
				color: #cacaca !important;
			}
			img {
				position: absolute;
				// height: 40px;
				// width: 40px;
				right: 5px;
				cursor: pointer;
			}
		}
		.morebox {
			margin-top: 0;
		}
	}
	.newsbox {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		// max-height: 420px;
		min-height: 420px;
		position: relative;
		.pagination-box {
			position: absolute;
			bottom: -40px;
			left: 50%;
			transform: translateX(-50%);
		}
		// min-height: 600px;
		.aloneInfoItem {
			margin: 0 16px 30px 0;
			width: 288px;
			height: 178px;
			background: rgba(255, 255, 255, 0.39);
			border: 1px solid #e7e7e7;
			padding: 20px 0 0 0;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			cursor: pointer;
			&:hover {
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				// background:  linear-gradient(90deg, #448DF7 0%, #9BBEFF 100%) ;
				background: url(../../../assets/imgs/member/bgimg.png) #5e97ee no-repeat 100%;
				.memberName,
				.memberSite {
					color: #fff;
				}
				.memberName::before {
					border: 2px solid #fff;
					opacity: 1;
					background: #fff;
				}

				.memberSite {
					.iconwarp {
						color: #fff;
					}
				}
			}
			&:nth-child(4n) {
				margin-right: 0;
			}
			.memberName {
				width: 95%;
				font-size: 18px;
				font-weight: 500;
				line-height: 32px;
				color: #333333;
				position: relative;
				text-align: center;
			}
			.memberName::before {
				content: '';
				position: absolute;
				width: 44px;
				height: 0px;
				border: 2px solid #448df7;
				opacity: 1;
				background: #448df7;
				left: 50%;
				transform: translateX(-50%);
				top: 32px;
			}
			.memberGrade {
				width: 161px;
				height: 32px;
				background: #fad65c;
				font-size: 16px;
				line-height: 32px;
				color: #7a4702;
				text-align: center;
				margin: 25px 0 10px 0;
			}
			.memberSite {
				font-size: 16px;
				line-height: 32px;
				color: #999999;
				.iconwarp {
					font-size: 18px;
					color: #448df7;
					margin-right: 2px;
				}
			}
		}
	}
}
.dialogWarp {
	/deep/.singupdialogcenter {
		font-size: 16px;
		line-height: 36px;
		text-indent: 32px;
		padding: 0 20px;
	}
}
</style>


